import { render, staticRenderFns } from "./schoolProfile.vue?vue&type=template&id=6be14f66&scoped=true"
import script from "./schoolProfile.vue?vue&type=script&lang=js"
export * from "./schoolProfile.vue?vue&type=script&lang=js"
import style0 from "./schoolProfile.vue?vue&type=style&index=0&id=6be14f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be14f66",
  null
  
)

export default component.exports